const STORAGE_KEY = "tasks:lastProjectId";

function canUseLocalStorage(): boolean {
  try {
    return (
      typeof window !== "undefined" &&
      typeof localStorage !== "undefined" &&
      typeof localStorage.getItem === "function"
    );
  } catch {
    return false;
  }
}

export function getLastProjectId(): string | null {
  if (!canUseLocalStorage()) return null;
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setLastProjectId(projectId: string | null): void {
  if (!canUseLocalStorage()) return;
  try {
    if (projectId) localStorage.setItem(STORAGE_KEY, projectId);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore quota / private mode */
  }
}
